import { useQuery } from '@tanstack/react-query';
import { RorosObservabilityService } from '@/services/RorosService';
import { rorosKeys } from './keys';

const STALE_TIME = 2 * 60_000;
const GC_TIME = 5 * 60_000;

// ─── Queries ───────────────────────────────────────────────────────────────

export function useRorosHealth() {
  return useQuery({
    queryKey: rorosKeys.observability.health,
    queryFn: () => RorosObservabilityService.getHealth(),
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}

export function useRorosDomainHealth(domainId: string) {
  return useQuery({
    queryKey: rorosKeys.observability.domainHealth(domainId),
    queryFn: () => RorosObservabilityService.getDomainHealth(domainId),
    enabled: !!domainId,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}

export function useRorosCeoScorecard() {
  return useQuery({
    queryKey: rorosKeys.observability.ceoScorecard,
    queryFn: () => RorosObservabilityService.getCeoScorecard(),
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}

export function useRorosDomainScorecard(domainId: string) {
  return useQuery({
    queryKey: rorosKeys.observability.domainScorecard(domainId),
    queryFn: () => RorosObservabilityService.getDomainScorecard(domainId),
    enabled: !!domainId,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}

export function useRorosTrends(params?: Record<string, string>) {
  return useQuery({
    queryKey: [...rorosKeys.observability.trends, params] as const,
    queryFn: () => RorosObservabilityService.getTrends(params),
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}

export function useRorosMura() {
  return useQuery({
    queryKey: rorosKeys.observability.mura,
    queryFn: () => RorosObservabilityService.getMura(),
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}
